import React from 'react';
import { Grid } from '@material-ui/core';
import { CategoryItem } from '../../shared/types';
import { Link } from 'neon-design-system';
import CategoryCard from './CategoryCard';
import { baseUrls } from '../../utils/baseUrls.utils';

interface FeaturedCategoryListViewProps {
	items: CategoryItem[];
	chipsFromMdBreakpoint?: boolean;
}

const FeaturedCategoryCardListView = ({ items }: FeaturedCategoryListViewProps) => {

	return (
		<Grid
			container
			spacing={2}>
			{items.map((item: CategoryItem) => {
				return (
					<Grid
						key={item._id}
						item
						sm={4}
						md={4}
						xs={12}
					>
						<Link to={getCategoryLink(item)}>
							<CategoryCard
								name={item.name}
								id={item._id}
								imageUrl={item.smallImage ?? ''}/>
						</Link>
					</Grid>
				)
			})}
		</Grid>
	);
};

export default FeaturedCategoryCardListView;

const getCategoryLink = (item: CategoryItem) => `${baseUrls.browse.main}/${item._id}`;
